import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

import VideoPlayer from '../common/VideoPlayer';

const Winery = () => {

    return (
        <>
            <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
                <Card.Body>
                    <Card.Title className='industrial-modeling-title'>IoT Winery</Card.Title>
                    <Card.Text className='industrial-modeling-text'>
                    Technology and equipment already collecting data are prime candidates for digital twins. IoT (internet of things) devices can be deployed in concert with 3D digital twins that display real - time sensor data. When data is being collected, it can be overlaid on a 3D facility digital twin that shows, in real time, the status of each item being tracked. 
                    <br />
                    <br /> For example, we helped a client build 3D digital twins of its facilities, including a winery, that displays wine volume, temperature, and other stats on each individual barrel using real - time IoT sensor data.
                    </Card.Text>
                    <Row >
                        <Col md={{span:8, offset:2}} className='container'>
                            <VideoPlayer videosource="assets/digital-twin/winery/video/Winery.mp4" class="winery-video container" />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className='no-border rounded-0 winery-carousel-section py-4 py-md-5 my-5 my-md-0 container'>
            <Row>
                <Col>
                <Carousel className='winery-carousel' interval={null}>
                <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/winery/images/w_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
                </Col>
            </Row>
            </Card>
        </>
    )
}

export default Winery
